






































































































































































































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";
import moment from "moment";
import MyForm from "@/mixins/form";

@Component
export default class extends Mixins(MyForm) {
  @Prop() stadiumId!: number;

  @Prop() grounds!: any[];

  @Prop() addData!: any;

  @Prop() allowHalfAnHour!: any;

  priceType = "0";

  renderHour(hto: any, mto: any, hfrom: any, mfrom: any): number {
    const x: moment.Moment = moment({ h: hto, m: mto });
    const y: moment.Moment = moment({ h: hfrom, m: mfrom });

    const duration = moment.duration(x.diff(y));

    return duration.as("hours");
  }

  renderTime(v:any,d:any) {
    if(v==undefined) {
      return d || ""
    }
    return v
  }

  renderWeeks(){
    var weeks=this.form.getFieldValue("weeks")||this.addData.weeks;
    if(weeks==undefined){
      return 0
    }
    return weeks.length
  }

  changePriceType(e: any) {
    // console.log(e);
    this.priceType = e.target.value;
  }

  handleSubmit() {
    this.form.validateFields((err: any, values: any) => {
      if (!err) {
        this.showTsConfirm({
          title: "确认信息",
          content: "确定要提交吗？",
          onOk: async () => {
            this.confirmLoading = true;
            const res = await this.$store.dispatch("stadium/addStadiumPrice", {
              stadium_id: this.stadiumId,
              type:this.addData.type||1,
              ...values
            });
            if (res && res.Message && res.Message === "success") {
              this.$message.success(res.Message);
              this.handleCancel();
            } else {
              this.$message.error(res.Message);
            }
            this.confirmLoading = false;
          }
        });
      }
    });
  }
}
